import { useEffect, useState } from "react";
import "./Setting.scss";
import { useSearchParams } from "react-router-dom";
import { t } from "i18next";
import Documentation from "./Documentation/Documentation";
import ContractDetailIcon from "../../utils/Images/ContractDetailIcon";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Assessment/Header/Header";
import License from "./License/License";
import { getLicenseList } from "../../service/License/License";
import { SettingAppEnums } from "../../utils/Enums/SettingAppEnums";
import StaffIcon from "../../utils/Images/StaffIcon";
const Settings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedTab, setSelectedTab] = useState<string>(
    searchParams.get("at") || SettingAppEnums.TAB_LICENSE,
  );
  const [pageSize] = useState<number>(10);
  const [currentPage] = useState<number>(1);
  const [licenseList, setLicenseList] = useState<any>([]);
  const [licenseWithStatus, setLicenseWithStatus] = useState<any[]>(
    JSON.parse(localStorage.getItem("licenseWithStatus") ?? "[]"),
  );
  useEffect(() => {
    getLicenseListApi();
  }, []);

  useEffect(() => {
    const params: Record<string, string> = { at: selectedTab };
    setSearchParams(params, { replace: true });
  }, [selectedTab]);
  const handleActiveTab = (tabName: any) => {
    setSelectedTab(tabName);
  };
  const renderContent = (activeTabs?: string) => {
    switch (activeTabs) {
      case SettingAppEnums.TAB_STAFF_AUG:
        return <Documentation />;
      case SettingAppEnums.TAB_LICENSE:
        return (
          <License
            licenseList={licenseList}
            setLicenseWithStatus={setLicenseWithStatus}
          />
        );
      default:
        return null;
    }
  };
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const getLicenseListApi = async () => {
    const res = await getLicenseList(currentPage, pageSize);
    if (res?.status === 200) {
      setLicenseList(res?.data?.data);
    }
  };
  const isStaffAugEnabled = licenseWithStatus.some(
    (item) =>
      item["license.name"] === SettingAppEnums.LICENSE_STAFF_AUGMENTATION &&
      item.isEnabled === true,
  );
  return (
    <>
      <Header />
      <div className="container-fluid settingsSec">
        <div className="row">
          <div className="col-md-12">
            <div className="skillsNameSec">
              <div className="profileHeader">
                <span className="name">{t("GENERAL.SETTINGS")}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex flex-wrap mt-4 mb-4">
          <div className="col-sm-12 col-md-3 col-lg-2 settingsSidebar">
            <div className="sidebar">
              {/* license */}
              <div className="assessmentList">
                <div
                  className={`tab ${selectedTab === SettingAppEnums.TAB_LICENSE ? "active" : ""}`}
                  onClick={() => {
                    handleActiveTab(SettingAppEnums.TAB_LICENSE);
                  }}
                >
                  <div className="iconJobText">
                    <ContractDetailIcon />
                    <h6>{t("SETTING.LICENSE")}</h6>
                  </div>
                </div>
              </div>
              {isStaffAugEnabled && (
                <div className="assessmentList">
                  <div
                    className={`tab ${selectedTab === SettingAppEnums.TAB_STAFF_AUG ? "active" : ""}`}
                    onClick={() => {
                      handleActiveTab(SettingAppEnums.TAB_STAFF_AUG);
                    }}
                  >
                    <div className="iconJobText">
                      <StaffIcon />
                      <h6>{t("GENERAL.STAFF_AUGMENTATION")}</h6>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="col-sm-12 col-md-9 col-lg-10">
            <div className="content-area">{renderContent(selectedTab)}</div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Settings;
